<template>
    <div>
        <ContentHeader path-set-type="append" :gameplan-nav="false" />
        <div class="content-wrapper" v-loading = 'loading'>
            <el-row>
                <div class="mask" v-if="isMask"></div>
                <div class="title" style="margin-top: -40px;">
                    <div class="left">活动主题信息</div>
                    <div class="right" v-if="isAllbtn">
                        <DialogPop
                        @confirm="sendBackall"
                        @getRejectaccount="getRejectaccount"
                        :marLeft="true"
                        :isReject="true"
                        isType="1"
                        btnText="全部退回"
                        centerText="是否确认全部退回？"
                        >
                        </DialogPop>
                        <DialogPop
                        @confirm="passThroughall"
                        isType="0"
                        btnText="全部通过"
                        centerText="是否确认全部通过？"
                        ></DialogPop>
                    </div>
                </div>
                <div class="card-box" >
                    <div class="card is-hover-shadow" >
                    <div class="left">
                        <div class="left-top">
                            <div class="left-top-left">
                                <div class="top-name">{{themeBasic.themeName}}</div>
                                <div class="top-sign">{{getBluename(themeBasic.orgLevel)}}</div>
                            </div>
                            <div class="left-top-right">
                                <span>{{getTime(themeBasic.themeStartTime)}}</span>
                                <span style="margin:0px 5px;">-</span>
                                <span>{{getTime(themeBasic.themeEndTime)}}</span>
                            </div>
                        </div>
                        <div class="pr-item-flex" v-if="themeBasic.gpPrDTOList">
                          <div style="margin-right:50px;margin-top:12px;"><span class="font-weight-bold">PR信息：</span>{{prInfo}}</div>
                          <div style="margin-top:12px;"><span class="font-weight-bold">品牌信息：</span>{{brandInfo}}</div>
                        </div>
                        <div class="left-third">
                        <div class="left-third-left">
                            <span>活动执行数据收集模板</span>
                            <span @click="viewChangepop()" style="color: #409EFF;margin-left: 20px;cursor: pointer;">配置详情</span>
                        </div>
                        <div class="left-third-right">
                            <span class="text">活动执行手册</span>
                            <span  class="text" style="color: #409EFF;margin-left: 20px;cursor: pointer;">
                                <span @click="viewPdf()" v-if="themeBasic.manualFileName && themeBasic.manualFileUri">{{ themeBasic.manualFileName }}</span>
                                <span v-else>暂无附件</span>
                            </span>
                        </div>
                        </div>
                        <!-- <div class="left-fouth" v-if="themeBasic.skuDTOList">
                            <div class="left-fouth-left">
                                <span>活动SKU：</span>
                            </div>
                            <div class="left-fouth-right">
                                <span>{{getSKU(themeBasic.skuDTOList,'、')}}</span>
                            </div>
                        </div> -->
                    </div>
                </div>
                </div>
                <div class="title"  style="margin-top: 5px;">
                    <span>额度调整：</span>
                    <span>{{buName.split('|')[0]}}</span>
                </div>
                <div class="cross" v-for="item of fullConfig" :key="item.themeStyleCode">
                    <QuotaPop
                        :channelForm="item"
                        :dataForm ='detailList'
                        :isAllbtn="isAllbtn"
                        @passThrough ='passThrough'
                        @sendBack = 'sendBack'
                        >
                    </QuotaPop>
                </div>
                <div v-if="showChangepop" class="changePop">
                    <configBuChangePop
                    @closeChangepop="closeChangepop"
                    :themeId="themeId"
                    ></configBuChangePop>
                </div>
            </el-row>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { commonUtils } from '@/utils/common'
    import gameplanApi from '../../api/gameplan'
    import ContentHeader from '@/components/content-header'
    import QuotaPop from './components/quotaChange-approval-pop.vue'
    import DialogPop from './components/dialog-pop.vue'
    import configBuChangePop from './components/config-buChange-pop.vue'
    export default {
      name: 'quotaChange-approval-detail',
      components: {
        ContentHeader,
        QuotaPop,
        DialogPop,
        configBuChangePop
      },
      data () {
        return {
            themeBasic: {},
            detailList: {},
            fullConfig:[],
            themeId:'',
            isAllbtn:false,
            buCode:"",
            isPassThroughall:false, // 是否是全部通过
            isSendbackall:false, // 是否是全部退回
            loading: false,
            buName:'',
            rejectAccount:'', // 理由
            showChangepop: false,
            isMask:false,
            prInfo:'',
            brandInfo:''
        }
      },
      computed: {
        ...mapGetters(['userInfo']),
      },
      watch: {},
      created () {
        this.themeId = this.$route.query.themeId
        this.buCode = this.$route.query.buCode
        this.buName = this.$route.query.buName
        if (this.$route.query.activityType == '01') {
            this.isAllbtn = true
        } else {
            this.isAllbtn = false
        }
        this.init()
      },
      mounted () {},
      updated () {
      },
      methods: {
        init () {
            this.getDetailinfo()
        },
        lockScroll() {
            let widthBar = 17, root = document.documentElement;
            if (typeof window.innerWidth == 'number') {
                widthBar = window.innerWidth - root.clientWidth;
            }
            root.style.overflow = 'hidden';
            root.style.borderRight = widthBar + 'px solid transparent';
        },
        unlockScroll() {
            let root = document.documentElement;
            root.style.overflow = '';
            root.style.borderRight = '';
        },
        viewPdf () {
            if (this.themeBasic.manualFileUri) {
                window.open(commonUtils.getImageUrl(this.themeBasic.manualFileUri))
            } else {
                console.log('manualFileUri为空');
            }
        },
        viewChangepop () {
            this.isMask = true
            this.showChangepop = true
            this.lockScroll()
        },
        closeChangepop () {
            this.isMask = false
            this.showChangepop = false
            this.unlockScroll()
        },
        getSKU (arr,sign) {
            if (arr && arr.length > 0) {
                let name = arr.map((item)=>{
                return item.skuName
                }).join(sign)
                return name
            } else {
                return '暂无数据'
            }
        },
        // 理由
        getRejectaccount (val) {
            this.rejectAccount = val
        },
        getBluename (name) {
            if (name == 'region') {
                return 'Region'
            } else if (name == 'bu') {
                return 'BU'
            } else if (name == 'hq') {
                return 'HQ'
            } else {
                return 'error'
            }
        },
        getChannel(a,b){
            let themeChannels = a || []
            let arr = themeChannels.map((item) => {
                    return item.themeChannelEnName
                }).join(b)
            return arr
        },
        getTime (timestamp) {
        if (timestamp === 0 || timestamp == null) {
            return ''
        } else {
            var date = new Date(parseInt(timestamp)) // 时间戳为13位的话需要parseInt下
            const Y = date.getFullYear() + '-'
            const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
            const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
            // const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
            // const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
            // const s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
            return Y + M + D
        }
        },
        getShowDetail(){
          let brandInfo = []
          let prInfo = []
          const gpPrDTOList = this.themeBasic.gpPrDTOList
          if(gpPrDTOList){
            gpPrDTOList.forEach(item=>{
              let data = ''
              if(item.brandName&&item.subBrandName)  data = item.brandName+'-'+item.subBrandName
              else data = item.brandName||item.subBrandName
              if(brandInfo.indexOf(data)===-1) {
                brandInfo.push(data)
              }
              prInfo.push(item.prNumber+'-'+item.prName)
            })
            this.brandInfo = brandInfo.join('、')
            this.prInfo = prInfo.join('、')
          }
        },
        async getDetailinfo () {
            this.loading = true
            let params = {
                // themeId:this.themeId
                'themeId':this.themeId,
                'buCode':this.buCode,
                'detailOrConfig':'1'
            }
            let {data} = await gameplanApi.getGamepalnThemeInfo(params)
            if (data.resultCode == '0') {
                this.themeBasic = data.resultData.themeInfo.themeBasic
                // this.fullConfig = data.resultData.themeInfo.themeBasic.themeChannels
                let detailList = data.resultData.themeInfo.detailList
                this.getShowDetail()
                if (this.isAllbtn == true) {
                    for (let i = 0; i < detailList.length; i++) {
                        if (detailList[i].subAssignList == null || detailList[i].subAssignList.length == 0 || detailList[i].subAssignList[0].assignStatus !== 50){
                            detailList.splice(i,1)
                            i--
                        }
                    }
                } else {
                    for (let i = 0; i < detailList.length; i++) {
                        if (detailList[i].subAssignList == null || detailList[i].subAssignList.length == 0 || detailList[i].subAssignList[0].assignStatus !== 100){
                            detailList.splice(i,1)
                            i--
                        }
                    }
                }
                for (let item of detailList) {
                    if (item.subAssignList[0].buChangeQty == null) {
                       item.subAssignList[0].buChangeQty = item.subAssignList[0].assignQty
                    }
                }
                this.detailList = detailList
                let testDatalist = JSON.parse(JSON.stringify(this.detailList))
                let newArr = []
                for (let i = 0; i < testDatalist.length; i++) {
                    for (let item of testDatalist[i].subAssignList) {
                        newArr.push(item)
                    }
                }
                // console.log(newArr,'newArr');
                for (let j= 0; j < newArr.length; j++) {
                    if (newArr[j].assignQty == newArr[j].buChangeQty) {
                        newArr.splice(j, 1);
                        j--;//i需要自减，否则每次删除都会讲原数组索引发生变化
                    }
                }
                // console.log(newArr,'newArr2');
                if (newArr.length == 0 && this.isAllbtn == true) {
                    this.$message.warning('当前活动配额审批已经全部审批，返回上一页')
                    this.$router.go(-1)
                }
                let arr = []
                for (let item of this.detailList) {
                if (item.themeDetail.themeChannelName && item.themeDetail.themeChannelCode) {
                    arr.push({
                    'themeChannelCode':item.themeDetail.themeChannelCode,
                    'themeChannelName':item.themeDetail.themeChannelName.split('|')[0],
                    'themeChannelEnName':item.themeDetail.themeChannelName.split('|')[1],
                    'themeStyleCode':item.themeDetail.themeStyleCode
                    })
                }
                }
                let len = arr.length
                for (let i = 0; i < len; i++) {
                for (let j = i + 1; j < len; j++) {
                    if (arr[i].themeStyleCode === arr[j].themeStyleCode) {
                    arr.splice(j, 1)
                    len-- // 减少循环次数提高性能
                    j-- // 保证j的值自加后不变
                    }
                }
                }
                this.fullConfig = arr
                this.loading = false
            }
        },
        quotaApprove (params) {
            this.loading = true
            gameplanApi.getGamepalnQuotaapprove(params).then((res)=>{
                if (res.data.resultCode == '0') {
                    if (params.detailList[0].subAssignList[0].processAction == '02') {
                        if (this.isPassThroughall == true) {
                            this.$message.success('活动配额批量审批已通过');
                            this.$router.go(-1)
                        } else {
                            this.$message.success('活动配额审批已通过');
                            this.$router.go(0)
                        }

                    } else {
                        if ((this.isSendbackall == true)) {
                            this.$message.success('活动配额批量审批已退回');
                            this.$router.go(-1)
                        } else {
                            this.$message.success('活动配额审批已退回');
                            this.$router.go(0)
                        }
                    }
                    this.loading = false
                } else {
                    this.loading = false
                }

            })
        },

        // 通过
        passThrough (item) {
            let arr = []
            for (let i of item) {
                arr.push({
                    'themeId':i.themeDetail.themeId,
                    'themeDetailId':i.themeDetail.themeDetailId,
                    'buCode':this.buCode,
                    'processAction':'02',
                    'assignStartTime':i.subAssignObj.assignStartTime,
                    'assignEndTime':i.subAssignObj.assignEndTime,
                    'assignId':i.subAssignObj.assignId
                })
            }
            let ThemeInfoVO = {
                detailList:[
                    {
                        subAssignList:arr
                    }
                ]
            }
            // console.log(ThemeInfoVO,'ThemeInfoVO-额度审批通过');
            this.quotaApprove(ThemeInfoVO)
        },
        // 退回
        sendBack (val) {
            let item = val.popData
            let arr = []
            for (let i of item) {
                arr.push({
                    'themeId':i.themeDetail.themeId,
                    'themeDetailId':i.themeDetail.themeDetailId,
                    'buCode':this.buCode,
                    'processAction':'03',
                    'assignStartTime':i.subAssignObj.assignStartTime,
                    'assignEndTime':i.subAssignObj.assignEndTime,
                    'assignId':i.subAssignObj.assignId
                })
            }
            let ThemeInfoVO = {
                detailList:[
                    {
                        subAssignList:arr,
                        quotaRejectReason:val.rejectAccount,
                        quotaRejectPerson:this.userInfo.clientName
                    }
                ]
            }
            // console.log(ThemeInfoVO,'ThemeInfoVO-额度审批退回');
            this.quotaApprove(ThemeInfoVO)
        },
        // 全部通过
        passThroughall () {
            let ThemeInfoVO = {
                detailList:[
                    {
                        subAssignList:[]
                    }
                ]
            }
            let testDatalist = JSON.parse(JSON.stringify(this.detailList))
            // for (let i = 0; i < testDatalist.length; i++) {
            //     if ((testDatalist[i].subAssignList[0].assignQty == testDatalist[i].subAssignList[0].buChangeQty) || testDatalist[i].subAssignList[0].buChangeQty == null) {
            //         testDatalist.splice(i, 1);
            //         i--;//i需要自减，否则每次删除都会讲原数组索引发生变化
            //     }
            // }
            if (testDatalist.length == 0) {
                this.$message.warning('当前活动相关提报已经全部操作过，返回上一页')
                this.$router.go(-1)
            } else {
                let arr = []
                for (let item of testDatalist) {
                    for (let item2 of item.subAssignList) {
                        arr.push({
                        themeId:item.themeDetail.themeId,
                        themeDetailId:item.themeDetail.themeDetailId,
                        buCode:this.buCode,
                        processAction:'02',
                        'assignStartTime':item2.assignStartTime,
                        'assignEndTime':item2.assignEndTime,
                        'assignId':item2.assignId
                        })
                    }
                }
                ThemeInfoVO.detailList[0].subAssignList = arr
                this.isPassThroughall = true
                this.quotaApprove(ThemeInfoVO)
                // console.log(arr,'ThemeInfoVO-全部通过');
            }
        },
        // 全部退回
        sendBackall () {
            let ThemeInfoVO = {
                detailList:[
                    {
                        subAssignList:[]
                    }
                ]
            }
            let testDatalist = JSON.parse(JSON.stringify(this.detailList))
            // for (let i = 0; i < testDatalist.length; i++) {
            //     if ((testDatalist[i].subAssignList[0].assignQty == testDatalist[i].subAssignList[0].buChangeQty) || testDatalist[i].subAssignList[0].buChangeQty == null) {
            //         testDatalist.splice(i, 1);
            //         i--;//i需要自减，否则每次删除都会讲原数组索引发生变化
            //     }
            // }
            if (testDatalist.length == 0) {
                this.$message.warning('当前活动相关提报已经全部操作过，返回上一页')
                this.$router.go(-1)
            } else {
                let arr = []
                for (let item of testDatalist) {
                    for (let item2 of item.subAssignList) {
                        arr.push({
                        themeId:item.themeDetail.themeId,
                        themeDetailId:item.themeDetail.themeDetailId,
                        buCode:this.buCode,
                        processAction:'03',
                        'assignStartTime':item2.assignStartTime,
                        'assignEndTime':item2.assignEndTime,
                        'assignId':item2.assignId
                        })
                    }
                }
                ThemeInfoVO.detailList[0].subAssignList = arr
                ThemeInfoVO.detailList[0].quotaRejectReason = this.rejectAccount
                ThemeInfoVO.detailList[0].quotaRejectPerson = this.userInfo.clientName
                this.isSendbackall = true
                this.quotaApprove(ThemeInfoVO)
                // console.log(ThemeInfoVO,'ThemeInfoVO-全部驳回');
            }
        },
    }
}
</script>
<style lang="scss" scoped>
    .is-hover-shadow:hover {
        box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.2);
    }
    .content-wrapper {
        min-height: calc(100vh - 320px) !important;
        font-family: SourceHanSansSC-regular;
        .title {
            height: 60px;
            line-height: 60px;
            text-align: left;
            color: rgba(16, 16, 16, 1);
            font-size: 18px;
            font-weight: 600;
            display: flex;
            .left {
                flex: 1;
            }
            .right {
                height: 35px;
                line-height: 35px;
                margin-top: 15px;
                font-size: 14px;
                display: flex;
                color: #FFFFFF;
                text-align: center;
            }
        }
        .card-box {
            .card {
                display: flex;
                justify-content: flex-start;
                padding: 20px 20px 20px 20px;
                background-color: #FFFFFF ;
                border-radius: 8px;
                font-size: 14px;
                .left {
                    text-align: left;
                    color: #101010;
                    flex: 1;
                    .left-top {
                        // line-height: 27px;
                        display: flex;
                        .left-top-left {
                            width: 80%;
                            font-size: 18px;
                            display: flex;
                            .top-name {
                                font-weight: 600;
                                // padding: 2px 0px;
                                // line-height: 20px;
                                word-wrap: break-word;
                                word-break: normal;
                                word-break: break-all;
                            }
                            .top-sign {
                                // padding: 2px 8px;
                                color: #FFFFFF;
                                background-color: #40A5EE;
                                margin-left: 10px;
                                // border-radius: 3px;
                                // height: 20px;
                                padding: 0px 8px;
                                line-height: 18px;
                                height: 18px;
                                font-size: 14px;
                                margin-top: 2px;
                                font-weight: 600;
                            }
                        }
                        .left-top-right {
                            flex: 1;
                            font-size: 14px;
                            text-align: right;
                            word-wrap: break-word;
                            word-break: normal;
                            word-break: break-all;
                            line-height: 20px;
                        }
                    }
                    .left-third {
                        font-size: 14px;
                        height: 20px;
                        line-height: 20px;
                        margin-top: 12px;
                        display: flex;
                        justify-content: flex-start;
                        .left-third-left {
                            display: flex;
                            justify-content: flex-start;
                            margin-right: 80px;
                        }
                        .left-third-right {
                            display: flex;
                            justify-content: flex-start;
                            .img {
                            width: 20px;
                            margin-right: 3px;
                            }
                            // .text {
                            //     margin: 0px 3px 0px 3px ;
                            //     // color: #539EFE;
                            // }
                        }
                    }
                    .left-fouth {
                        display: flex;
                        font-size: 14px;
                        line-height: 20px;
                        margin-top: 12px;
                        .left-fouth-left {
                            width: 70px;
                        }
                        .left-fouth-right {
                            flex: 1;
                        }
                    }
                    .fouth {
                        font-size: 14px;
                        line-height: 20px;
                        color: #101010 ;
                        margin-top: 12px;
                    }
                }
                .right {
                    width: 20%;
                    text-align: right;
                    .right-time {
                        font-size: 14px;
                        line-height: 20px;
                        padding: 2px 0px;
                    }
                }
            }
        }
        .changePop {
            position: fixed;
            top: 5vh;
            left: calc((100vw - 800px)/2);
            width: 800px;
            padding: 20px;
            background-color: #FFFFFF;
            border-radius: 10px;
            z-index: 3;
            max-height: 90vh;
        }
        .mask{
            position: fixed;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background: rgba(0,0,0,.7) ;
            z-index: 3;
        }
    }
  .pr-item-flex{
    display:flex;
    flex-wrap:wrap;
  }
</style>
